module.exports = __webpack_public_path__ + "img/racetrack-fairview-turf.822b4c56.svg";